// extracted by mini-css-extract-plugin
export default {"container":"styles_container__E47fY","projectsContainer":"styles_projectsContainer__WPkq1"};